import React from 'react';
import { Helmet } from 'react-helmet';
import './legal.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>Terms of Service — dmyor</title>
        <link rel="canonical" href="https://www.dmyor.com/terms" />
        <meta name="description" content="Terms of service for using dmyor." />
        <meta property="og:title" content="Terms of Service — dmyor" />
        <meta property="og:description" content="Terms of service for using dmyor." />
        <meta property="og:image" content="https://dmyor.com/images/og-image.png" />
        <meta property="og:url" content="https://www.dmyor.com/terms" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="legal-header">
        <div className="legal-eyebrow">dmyor</div>
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: 09 December 2025</p>
      </div>

      <div className="legal-body">
        <p>
          Welcome to dmyor. These Terms of Service govern your use of the platform.
          By accessing or using dmyor, you agree to these Terms. Please read them carefully.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By using dmyor, you agree to abide by these Terms. If you do not agree with
          any part of these Terms, please refrain from using our services.
        </p>

        <h2>2. Description of Services</h2>
        <p>
          dmyor is a platform for writing, tracking, and documenting long-term visions
          and intentions. By using our services, you acknowledge that you understand the
          nature of the platform.
        </p>

        <h2>3. User Conduct</h2>
        <p>You are responsible for your actions on dmyor. Do not use the platform for:</p>
        <ul>
          <li>Posting content that infringes the rights of others or violates any applicable laws.</li>
          <li>Harassing, impersonating, or causing harm to others.</li>
          <li>Engaging in hate speech, discrimination, or abusive behavior.</li>
          <li>Creating spam or using automated means to interact with the platform.</li>
        </ul>

        <h2>4. Intellectual Property</h2>
        <p>
          You retain ownership of the content you create on dmyor. By posting content,
          you grant dmyor a non-exclusive, worldwide, royalty-free license to use, modify,
          and distribute your content solely for the purpose of providing our services.
        </p>

        <h2>5. Credits and Purchases</h2>
        <p>
          All credit purchases are final, non-refundable, and cannot be cancelled.
          You are solely responsible for managing your credits and ensuring their
          secure use on the platform.
        </p>

        <h2>6. Privacy and Data Usage</h2>
        <p>
          Our Privacy Policy outlines how we collect, use, and safeguard your information.
          By using dmyor, you agree to the terms described in our Privacy Policy.
        </p>

        <h2>7. Content Sharing</h2>
        <p>
          When you choose to share records publicly, they may be visible to other users.
          It is your responsibility to respect the privacy and rights of others while
          engaging in content sharing.
        </p>

        <h2>8. Disclaimer</h2>
        <p>
          dmyor does not guarantee the accuracy or reliability of the content shared on
          the platform. Users are solely responsible for the content they create and share.
        </p>

        <h2>9. Termination</h2>
        <p>
          We reserve the right to suspend or terminate your account if you violate these
          Terms or engage in harmful behavior. You may also discontinue using dmyor at any time.
        </p>

        <h2>10. Changes to Terms</h2>
        <p>
          dmyor may update these Terms periodically. We will notify you of significant
          changes via email or by posting a notice on the website.
        </p>

        <h2>11. Contact</h2>
        <p>
          For questions or concerns about these Terms, contact us at{' '}
          <a href="mailto:support@dmyor.com">support@dmyor.com</a>.
        </p>
      </div>
    </div>
  );
};

export default Terms;
